// extracted by mini-css-extract-plugin
export default {"contenedor":"card_contenedor__rAGfL","tituloDiv":"card_tituloDiv__8ElDR","texto":"card_texto__W8nJj"};